import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { InfoApi } from "./info/info.api";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { AccountsApi } from "./jpgrondin/accounts/apis/accounts.api";
import { CustomersApi } from "./jpgrondin/customers/apis/customers.api";
import { ProjectPhasesApi } from "./jpgrondin/projects/apis/project-phases.api";
import { ProjectTypeStepsApi } from "./jpgrondin/projects/apis/project-type-steps.api";
import { ProjectTypesApi } from "./jpgrondin/projects/apis/project-types.api";
import { ProjectsApi } from "./jpgrondin/projects/apis/projects.api";
import { TicketCommentRepliesApi } from "./jpgrondin/tickets/apis/ticket-comment-replies.api";
import { TicketCommentsApi } from "./jpgrondin/tickets/apis/ticket-comments.api";
import { TicketCustomersApi } from "./jpgrondin/tickets/apis/ticket-customers.api";
import { TicketEventsApi } from "./jpgrondin/tickets/apis/ticket-events.api";
import { TicketFilesApi } from "./jpgrondin/tickets/apis/ticket-files.api";
import { TicketParticipantsApi } from "./jpgrondin/tickets/apis/ticket-participants.api";
import { TicketTagsApi } from "./jpgrondin/tickets/apis/ticket-tags.api";
import { TicketTicketTagsApi } from "./jpgrondin/tickets/apis/ticket-ticket-tags.api";
import { TicketsApi } from "./jpgrondin/tickets/apis/tickets.api";
import { TicketEventGateway } from "./jpgrondin/tickets/gateways/ticket-event.gateway";
import { TimeEntriesApi } from "./jpgrondin/time-entries/apis/time-entries.api";
import { WorkgroupsApi } from "./jpgrondin/workgroups/apis/workgroups.api";

@NgModule({
    providers: [
        AccountsApi,
        CustomersApi,
        InfoApi,
        ProjectPhasesApi,
        ProjectTypesApi,
        ProjectTypeStepsApi,
        ProjectsApi,
        TicketCommentRepliesApi,
        TicketCommentsApi,
        TicketCustomersApi,
        TicketEventGateway,
        TicketEventsApi,
        TicketFilesApi,
        TicketParticipantsApi,
        TicketTagsApi,
        TicketTicketTagsApi,
        TicketsApi,
        TimeEntriesApi,
        WorkgroupsApi,

        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ]
})
export class ApiModule {}
